class CartMain extends Component {
	constructor(el) {
		super(el);
		this.form = this.$el.closest('form');
		this.debounceInterval = undefined;
		this.addEventListeners();
	}

	reRenderCart(data) {
		const htmlData = new DOMParser().parseFromString(data, 'text/html');
		const componentSource = htmlData.querySelector('[data-step-cart]');
		this.$el.innerHTML = componentSource.innerHTML;

		Component.initComponents();
	}

	updateCart(params) {
		let formData = new FormData(this.form);
		let action = Object.keys(params).length ? params : window.location.pathname;
		EventBus.getInstance().dispatchEvent('showGlobalSpinner');

		fetch(action, {
			method: 'POST',
			body: formData
		})
		.then(res => res.text())
		.then(data => this.reRenderCart(data))
		.finally(() => EventBus.getInstance().dispatchEvent('hideGlobalSpinner'));
	}

	addEventListeners() {
		EventBus.getInstance().addEventListener('orderUpdateStepCart', e => {
			this.debounceInterval && clearTimeout(this.debounceInterval);
			this.debounceInterval = setTimeout(() => this.updateCart(e.detail), 300);
		});
	}
}